import type { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "landed" | "missed" | "primary" | "neutral" | "warning";
  count?: number;
}

const styles: Record<NonNullable<Props["variant"]>, string> = {
  landed: "bg-emerald-600 active:bg-emerald-500 text-white",
  missed: "bg-neutral-700 active:bg-neutral-600 text-neutral-100",
  primary: "bg-blue-600 active:bg-blue-500 text-white",
  neutral: "bg-neutral-800 active:bg-neutral-700 text-neutral-100",
  warning: "bg-amber-600 active:bg-amber-500 text-white",
};

export function TapButton({
  variant = "neutral",
  count,
  children,
  onClick,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      onClick={(e) => {
        if (typeof navigator !== "undefined" && navigator.vibrate) {
          navigator.vibrate(10);
        }
        onClick?.(e);
      }}
      className={`tap-btn ${styles[variant]} disabled:opacity-40 disabled:cursor-not-allowed ${rest.className ?? ""}`}
    >
      <span className="text-base leading-tight">{children}</span>
      {typeof count === "number" && (
        <span className="ml-2 tabular-nums opacity-75 text-sm">{count}</span>
      )}
    </button>
  );
}
